import { environment } from './../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';


@Injectable()
export class AccessListService {
  accessSubmenuList: any[] = [];
  
  constructor(private httpClient: HttpClient, private router: Router) {
  }
  
  getAccessList() {
    let projectId = localStorage.getItem("selected_project_id");
    return this.httpClient.get(environment.baseUrl + 'ProjectAccessControl/getPageAccessByUserIdAndProjectId/' + projectId);
  }

  checkUrl(url) {
    return this.getAccessList().pipe(map((data: any) => {
      data.forEach(menu => {
        if(menu.length > 0) {
          menu.submenu.forEach(submenu => {
            this.accessSubmenuList.push(submenu.submenu_url);
          });
        }
      });
      if(this.accessSubmenuList.includes(url)){
        return true;
      }
      this.router.navigate(['/dashboard']);
        return false;
    }));
  }
}




// WEBPACK FOOTER //
// ./src/app/theme/services/access-list.service.ts